import React from 'react';
import { contactData } from '../data/mock';
import { Mail, Linkedin, Globe, Download, Phone } from 'lucide-react';

const Contact = () => {
  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <div className="contact-wrapper">
          <div className="contact-content">
            <span className="section-label">Connect</span>
            <h2 className="heading-2">Get in Touch</h2>
            <p className="body-medium contact-intro">
              For speaking engagements, consulting inquiries, or strategic partnerships, 
              please reach out through the channels below.
            </p>
          </div>
          
          <div className="contact-links">
            <a href="tel:+15124348560" className="contact-card">
              <div className="contact-icon">
                <Phone size={24} />
              </div>
              <div className="contact-info">
                <span className="contact-label">Phone</span>
                <span className="contact-value">+1 (512) 434-8560</span>
              </div>
            </a>
            
            <a href={`mailto:${contactData.email}`} className="contact-card">
              <div className="contact-icon">
                <Mail size={24} />
              </div>
              <div className="contact-info">
                <span className="contact-label">Email</span>
                <span className="contact-value">{contactData.email}</span>
              </div>
            </a>
            
            <a href={contactData.linkedin} target="_blank" rel="noopener noreferrer" className="contact-card">
              <div className="contact-icon">
                <Linkedin size={24} />
              </div>
              <div className="contact-info">
                <span className="contact-label">LinkedIn</span>
                <span className="contact-value">Connect on LinkedIn</span>
              </div>
            </a>
            
            <a href={contactData.company} target="_blank" rel="noopener noreferrer" className="contact-card">
              <div className="contact-icon">
                <Globe size={24} />
              </div>
              <div className="contact-info">
                <span className="contact-label">Company</span>
                <span className="contact-value">redspirecivil.com</span>
              </div>
            </a>
            
            <a 
              href="/documents/Executive-CV-Ruben-Wargner.pdf"
              download
              className="btn-primary download-btn"
            >
              <Download size={18} />
              Download CV
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;